import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import useStyles from './styles';

const ContentScheme = ({ gridDirection, gridWrap, valueContent }) => {
  const classes = useStyles();

  return (
    <>
      {React.Children.toArray(
        valueContent.map(item => {
          return (
            <>
              <Grid container direction={gridDirection} item wrap={gridWrap}>
                <Grid item xs={2}>
                  <img alt={item.alt} src={item.src} />
                </Grid>
                <Grid item xs={10}>
                  <Typography className={classes.contentTextOne} variant="h6">
                    {item.contentText}
                  </Typography>
                  <Typography className={classes.contentTextTwo} variant="h6">
                    {item.contentTextSec}
                  </Typography>
                </Grid>
              </Grid>
            </>
          );
        })
      )}
    </>
  );
};

export default ContentScheme;
